/**
 * 机构账号数据可见性配置
 *
 * 用于限制特定机构只能看到某个日期之后的报告——
 * 场景：机构在中途接入平台，此前的历史设备数据不属于他们。
 *
 * 键：机构名（TRIM 后匹配，容忍尾部空格脏数据）
 * 值：最早可见日期（YYYY-MM-DD，含）——早于此日期的报告在前端过滤掉
 *
 * 前端限制仅作 UX 层遮蔽；如需真正的数据隔离要走后端。
 *
 * 读取来源：localStorage.userOrg（登录后 fetchUser 必写此 key）
 */
export const orgMinVisibleDate = {
  '浙江大学医学院附属第一医院': '2026-07-05',
}

/**
 * 取当前登录机构的最早可见日期
 * @returns {string|null} 'YYYY-MM-DD' 或 null（无限制）
 */
export function getMinVisibleDateForCurrentUser() {
  try {
    const rawOrg = localStorage.getItem('userOrg') || ''
    const org = rawOrg.trim()  // 容忍历史脏数据，如 '浙江大学医学院附属第一医院 '
    return orgMinVisibleDate[org] || null
  } catch (e) {
    return null
  }
}
